import {
  appsInventoryApiListReceiptsGlobal,
  getAppsInventoryApiListReceiptsGlobalQueryKey,
} from '@/lib/api/generated/endpoints'
import type { StockReceiptOut } from '@/lib/api/generated/types.ts/stockReceiptOut'
import { queryOptions } from '@tanstack/react-query'

/**
 * Read-only stock receipts list (per-project).
 *
 * Backend contract (after scoped→global migration):
 *  - `GET /api/stock-receipts?project_id=<id>` → `StockReceiptOut[]`
 *    (bare array, not paginated). Each receipt embeds its `lines`.
 *
 * Consumed by the dedicated Receipts route (`features/receipts/`). No longer
 * surfaces as a tab inside the Inventory page (dropped in Phase 23).
 */

export const receiptsListQuery = (projectId: number) =>
  queryOptions({
    queryKey: getAppsInventoryApiListReceiptsGlobalQueryKey({ project_id: projectId }),
    queryFn: async ({ signal }) =>
      (await appsInventoryApiListReceiptsGlobal(
        { project_id: projectId },
        { signal },
      )) as unknown as readonly StockReceiptOut[],
    staleTime: 30_000,
    enabled: Number.isFinite(projectId) && projectId > 0,
  })
